import { render, staticRenderFns } from "./CustomerTermsservice.vue?vue&type=template&id=2ab29e3e&scoped=true"
import script from "./CustomerTermsservice.vue?vue&type=script&lang=js"
export * from "./CustomerTermsservice.vue?vue&type=script&lang=js"
import style0 from "./CustomerTermsservice.vue?vue&type=style&index=0&id=2ab29e3e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab29e3e",
  null
  
)

export default component.exports